export const customerAddConstants = {
    ADD_CUSTOMER_SUCCESS: 'ADD_CUSTOMER_SUCCESS',
    ADD_CUSTOMER_FAIL: 'ADD_CUSTOMER_FAIL'
  };
  